export const ROOT = '/'
export const HOME = '/home'
export const SIGN_IN = '/signin'
export const NEW_ENTRY = '/new/:entry'
export const ENTRIES = '/:category/:entry'
export const LEARN_MORE = '/learn-more'
export const PRIVACY_POLICY = '/privacy-policy'
export const NOT_FOUND = '*'
